
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"44","height":"44","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"fill":"#0071FF","d":"M6 7h32V5H6z"}}),_c('path',{attrs:{"fill":"#3E98FF","d":"M3 10h37V7H3z"}}),_c('path',{attrs:{"fill":"#DFE5F4","d":"M1 38h42V10H1z"}}),_c('path',{attrs:{"fill":"#3E98FF","d":"M40 16h-1.143v-2.857H36V12h4zM7 36H3v-4h1.142v2.857H7z"}}),_c('g',{attrs:{"fill":"#3E98FF"}},[_c('path',{attrs:{"d":"M14.632 26.772l2.15-3.742a.344.344 0 00.035-.26.33.33 0 00-.156-.21l-2.15-1.248a.322.322 0 00-.159-.044.337.337 0 00-.327.34v4.99c0 .19.124.293.24.326a.31.31 0 00.367-.152M21.854 24.253l6.506-3.775a.338.338 0 00.167-.296.34.34 0 00-.167-.296l-6.506-3.775a.315.315 0 00-.32 0l-7.015 4.071 7.016 4.071c.1.058.22.058.32 0"}}),_c('path',{attrs:{"d":"M27.849 22.199a.306.306 0 00-.394-.06l-5.42 3.143a.674.674 0 01-.682 0l-3.281-1.903a.318.318 0 00-.441.123l-3.252 5.661a.348.348 0 00.12.47l6.742 3.913c.157.089.35.035.44-.123l6.213-10.816a.337.337 0 00-.045-.408M28.36 29.348l-2.136-1.239a.324.324 0 00-.44.122L23.65 31.95a.337.337 0 00.045.41.31.31 0 00.394.06l4.272-2.479a.337.337 0 00.168-.296.337.337 0 00-.168-.296"}})]),_c('path',{attrs:{"d":"M0 0h44v44H0z"}})])])
          )
        }
      }
    